import React, {memo, useState, useEffect} from 'react';
import GutGemachtComponent from '../Components/Annotator/GutGemachtComponent';
import AnnotatorComponent from '../Components/Annotator/AnnotatorComponent';
import {getCurrentAnalyse} from "../API/annotatorApi";



/*
    Checks whether a key exists in local storage that gives information to show 'Gut Gemacht' or not.
 */
const checkGutGemachtVisibility = () => {
	if (localStorage.getItem('showGutGemacht') !== null) {
		return localStorage.getItem('showGutGemacht') === 'YES';
	} else {
		return false;
	}
};

/**
 * Verify if IndexedDB is supported by user's browser.
 */
if (!window.indexedDB) {
	console.log("Your browser doesn't support a stable version of IndexedDB. Annotator features will be compromised.");
}


function AnnotatorPage(props) {
    // const [analyse, setAnnotationData] = useState({});
    //
    // setAnnotationData(props.location.state.annotationData)

	const [annotator, setAnnotator] = useState(<></>);
       useEffect(async () => {
           let data = await getCurrentAnalyse(props.location.state.lvID)
		   //setAnnotationData(data)
		   const annotatorView = <AnnotatorComponent
                    lvComponentShow={true}
                    annotationComponentShow={true}
                    annotatorFooterShow={true}
                    adviceList={props.location.state.adviceList}
                    annotationData={data}
					//setAnnotationData={setAnnotationData}
                    lvstatus={props.location.state.lvstatus}
                    lvList={props.location.state.lvList.data}
                    links={props.location.state.links}
                    projectFirm={props.location.state.projectFirm}
                    projectuploader={props.location.state.projectuploader}
                    annotationCustomerView={false}
                    suggestComponentShow={true}
                    positionCategoryShow={true}
                    highlightPossible={true}
                    searchComponentShow={true}
                    deleteComponentShow={true}
                    summaryComponentShow={true}
                    saveComponentShow={true}
                    publishComponentShow={true}
                    editAdviceComponentShow={true}
                    ignoreComponentShow={true}
                    categoryComponentShow={true}
                    createAdviceComponentShow={true}
					risksDetectionComponentShow={true}
					annotationRulesetComponentShow={true}
                />
           setAnnotator(annotatorView)


       }, []);
    return (
		<>
            {/* Shows 'Gut Gemacht' only if true or else shows other Annotator Components. */}
            {checkGutGemachtVisibility() && <GutGemachtComponent/>}
            {!checkGutGemachtVisibility() && (
            	annotator

            )}
		</>
    );

}

export default memo(AnnotatorPage);
